import React from 'react';

const ContractContext = React.createContext(null);

export default ContractContext;
